<template>
    <!-- Modal para seleccionar pacientes -->
    <VueFinalModal v-model="showModal" classes="modal-container" content-class="modal-content4">
        <pacientes @datos-seleccionados2="handleDatosSeleccionados" />
    </VueFinalModal>

    <!-- Modal para seleccionar CIE-10 -->
    <VueFinalModal v-model="loadModalCie10" class="modal-container" content-class="modal-content4">
        <div class="modal-header d-flex justify-content-center rounded mb-2"
            style="background: linear-gradient(135deg, #0078be 0%, #005a8b 100%); padding: 12px;">
            <h6 class="modal-title text-center" style="color: white; margin: 0; font-weight: 600; font-size: 0.95rem;">
                <i class="fas fa-search me-2"></i>Seleccionar CIE-10
            </h6>
        </div>

        <div class="col-12 mb-2">
            <div class="input-group">
                <span class="input-group-text bg-light">
                    <i class="fas fa-search text-primary"></i>
                </span>
                <input placeholder="Ingrese el nombre del diagnóstico" class="form-control form-control-sm" type="text"
                    autocomplete="off" v-model="cie10.searchTerm" @input="toUppercase" />
            </div>
        </div>

        <DataTable :columns="columns2" :options="options2" :data="transactions2" class="table tablesorter" width="100%"
            @click="agregarCie10">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Código</th>
                    <th>Descripción</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in transactions2" :key="item.Codigo" :data-index="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.Codigo }}</td>
                    <td>{{ item.Descriptor }}</td>
                </tr>
            </tbody>
        </DataTable>
    </VueFinalModal>

    <!-- Modal para seleccionar medicina -->
    <VueFinalModal v-model="showModalInventario" teleport-to="body" :z-index-fn="() => 20000"
        classes="modal-container modal-inventario-overlay" content-class="modal-content4 modal-inventario">
        <div class="inventario-shell">
            <header class="inventario-head">
                <div class="inventario-head-icon" aria-hidden="true">
                    <i class="fas fa-pills"></i>
                </div>
                <div class="inventario-head-text">
                    <h6>Inventario disponible</h6>
                    <p>Selecciona un medicamento para agregarlo</p>
                </div>
                <button type="button" class="inventario-cerrar" aria-label="Cerrar" @click="cerrarModalInventario">
                    <i class="fas fa-times"></i>
                </button>
            </header>
            <div class="inventario-body">
                <Inventario
                    @medicamento-seleccionado="onMedicamentoSeleccionado"
                    @cerrar-modal="cerrarModalInventario"
                />
            </div>
        </div>
    </VueFinalModal>

    <VueFinalModal v-model="showModalFirma" teleport-to="body" :z-index-fn="() => 20000"
        classes="modal-container modal-firma-overlay" content-class="modal-content4 modal-firma">
        <div class="firma-shell">
            <header class="firma-head">
                <div class="firma-head-icon" aria-hidden="true">
                    <i class="fas fa-file-signature"></i>
                </div>
                <div class="firma-head-text">
                    <h6>Firma electrónica</h6>
                    <p v-if="firmando">Firmando, espere...</p>
                    <p v-else-if="!quiereFirmar">Elige cómo generar la receta</p>
                    <p v-else>Carga el certificado para firmar</p>
                </div>
                <button type="button" class="firma-cerrar" aria-label="Cerrar" :disabled="firmando" @click="cerrarModalFirma">
                    <i class="fas fa-times"></i>
                </button>
            </header>

            <div v-if="firmando" class="firma-body firma-loading">
                <div class="firma-spinner" aria-hidden="true"></div>
                <p class="firma-loading-text">Firmando, espere...</p>
            </div>

            <div v-else-if="!quiereFirmar" class="firma-body">
                <p class="firma-pregunta">¿Deseas firmar la receta electrónicamente?</p>
                <div class="firma-acciones">
                    <button type="button" class="btn-firma btn-firma-secundario" @click="rechazarFirma">
                        No
                    </button>
                    <button type="button" class="btn-firma" @click="aceptarFirma">
                        Sí
                    </button>
                </div>
            </div>

            <div v-else class="firma-body">
                <label class="firma-campo">
                    <span>Certificado .p12</span>
                    <input ref="inputFirma" type="file" accept=".p12,application/x-pkcs12"
                        @change="seleccionarArchivoFirma" />
                </label>
                <p v-if="archivoFirma" class="firma-archivo">{{ archivoFirma.name }}</p>
                <label class="firma-campo">
                    <span>Contraseña</span>
                    <div class="firma-clave">
                        <input v-model="claveFirma" :type="mostrarClaveFirma ? 'text' : 'password'"
                            autocomplete="new-password" placeholder="Contraseña del certificado" />
                        <button type="button" class="btn-ver-clave" :aria-label="mostrarClaveFirma ? 'Ocultar contraseña' : 'Ver contraseña'"
                            @click="mostrarClaveFirma = !mostrarClaveFirma">
                            <i :class="mostrarClaveFirma ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                    </div>
                </label>
                <div class="firma-acciones">
                    <button type="button" class="btn-firma btn-firma-secundario" @click="volverPreguntaFirma">
                        Volver
                    </button>
                    <button type="button" class="btn-firma" @click="confirmarFirma">
                        Firmar
                    </button>
                </div>
            </div>
        </div>
    </VueFinalModal>


    <div class="receta-container">
        <header class="receta-header">
            <div class="header-icon" aria-hidden="true">
                <i class="fas fa-prescription"></i>
            </div>
            <div class="header-text">
                <h6>Receta médica</h6>
                <label v-if="!codigoConsulta" class="fecha-field">
                    <input type="date" :value="paciente.fecha" @input="actualizarFecha($event.target.value)" />
                </label>
            </div>
            <button v-if="hasSavedData && !codigoConsulta" type="button" class="btn-limpiar" @click="confirmarBorrarDatos">
                <i class="fas fa-trash"></i> Limpiar
            </button>
        </header>

        <div v-if="codigoConsulta" class="receta-opciones">
            <p v-if="!resetarMedicamentos">Si el paciente no necesita receta, use Finalizar para guardar la consulta.</p>
            <button type="button" class="btn-generar" @click="alternarReceta">
                {{ resetarMedicamentos ? 'No generar receta' : 'Dar receta médica' }}
            </button>
        </div>

        <template v-if="mostrarFormularioReceta">
        <section v-if="!codigoConsulta" class="receta-block">
            <div class="block-head">
                <h6><i class="fas fa-user"></i> Paciente</h6>
                <button v-if="!codigoConsulta" type="button" class="btn-accion" @click="loadModal">
                    <i class="fas fa-search"></i> Buscar
                </button>
            </div>
            <div class="datos-grid">
                <div class="dato">
                    <span>DNI</span>
                    <strong :class="{ 'is-empty': !paciente.cedula }">{{ paciente.cedula || 'Sin seleccionar' }}</strong>
                </div>
                <div class="dato">
                    <span>Nombres</span>
                    <strong :class="{ 'is-empty': !paciente.nombres }">{{ paciente.nombres || 'Sin seleccionar' }}</strong>
                </div>
                <div class="dato">
                    <span>Edad</span>
                    <strong :class="{ 'is-empty': paciente.edad === '' || paciente.edad === null || paciente.edad === undefined }">{{ paciente.edad === '' || paciente.edad === null || paciente.edad === undefined ? '—' : paciente.edad }}</strong>
                </div>
            </div>
        </section>

        <section class="receta-block">
            <div class="block-head">
                <h6><i class="fas fa-stethoscope"></i> Diagnóstico CIE-10</h6>
                <button v-if="!codigoConsulta" type="button" class="btn-accion" @click="loadModal2">
                    <i class="fas fa-search"></i> Seleccionar
                </button>
            </div>
            <div v-if="!diagnosticosReceta.length" class="datos-grid datos-grid-cie">
                <div class="dato">
                    <span>Código</span>
                    <strong class="is-empty">Sin código</strong>
                </div>
                <div class="dato dato-wide">
                    <span>Descripción</span>
                    <strong class="is-empty">Sin diagnóstico</strong>
                </div>
            </div>
            <div v-for="item in diagnosticosReceta" :key="item.codigo" class="datos-grid datos-grid-cie">
                <div class="dato">
                    <span>Código</span>
                    <strong>{{ item.codigo }}</strong>
                </div>
                <div class="dato dato-wide">
                    <span>Descripción</span>
                    <strong>{{ item.nombre }}</strong>
                </div>
            </div>
        </section>

        <section class="receta-block">
            <div class="block-head">
                <h6><i class="fas fa-exclamation-triangle"></i> Signos de alarma</h6>
            </div>
            <textarea id="signosAlarma" class="form-control text-uppercase campo-texto"
                placeholder="Describe los signos de alarma" :value="signosAlarma" @input="actualizarSignosAlarma"
                rows="1"></textarea>
        </section>

        <section class="receta-block">
            <div class="block-head">
                <div>
                    <h6><i class="fas fa-pills"></i> Medicamentos</h6>
                    <p class="block-hint">Si el nombre está vacío, Enter abre el inventario.</p>
                </div>
                <button type="button" class="btn-accion btn-accion-solido" @click="agregarFila">
                    <i class="fas fa-plus"></i> Agregar
                </button>
            </div>

            <div class="table-responsive">
                <table class="medicamentos-table">
                    <thead>
                        <tr>
                            <th class="col-cantidad">Cantidad</th>
                            <th>Medicamento</th>
                            <th>Indicaciones</th>
                            <th class="col-accion">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(medicamento, index) in medicamentos" :key="index" class="medicamento-row">
                            <td data-label="Cantidad">
                                <cleave :modelValue="medicamento.cantidad"
                                    @update:modelValue="actualizarMedicamento(index, 'cantidad', $event)"
                                    :options="number" class="form-control form-control-sm text-center"
                                    placeholder="0" type="text" inputmode="decimal" />
                            </td>
                            <td data-label="Medicamento">
                                <div class="campo-con-accion">
                                    <textarea :value="medicamento.nombre"
                                        @input="actualizarMedicamento(index, 'nombre', $event.target.value)"
                                        @keydown="handleKeydown($event, index, 'nombre')"
                                        class="form-control form-control-sm text-uppercase"
                                        placeholder="Nombre del medicamento" rows="1"></textarea>
                                    <button type="button" class="btn-icono" title="Buscar en inventario"
                                        @click="abrirInventario(index)">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </td>
                            <td data-label="Indicaciones">
                                <textarea :value="medicamento.indicaciones"
                                    @input="actualizarMedicamento(index, 'indicaciones', $event.target.value)"
                                    class="form-control form-control-sm text-uppercase"
                                    placeholder="Indicaciones de uso" rows="1"></textarea>
                            </td>
                            <td data-label="Acción" class="celda-accion">
                                <button type="button" class="btn-icono btn-icono-peligro" title="Eliminar medicamento"
                                    @click="eliminarFila(index)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <section class="receta-block">
            <div class="block-head">
                <h6><i class="fas fa-clipboard-list"></i> Observaciones</h6>
            </div>
            <textarea id="observaciones" class="form-control text-uppercase campo-texto"
                placeholder="Observaciones adicionales" :value="observaciones"
                @input="actualizarObservaciones" rows="1"></textarea>
        </section>

        <div class="receta-footer">
            <button type="button" class="btn-generar" @click="generarReceta">
                <i class="fas fa-file-medical"></i> {{ textoBotonGenerar }}
            </button>
        </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';
import Pacientes from "./Pacientes.vue";
import Inventario from "./LoadMedicina.vue";
import { mapState, mapGetters, mapActions } from 'vuex';
import { toastMixin } from '@/mixins/toastMixin';

import { generatePdfReceta, crearPdfRecetaFirmable } from './generarReceta';
import { leerDiagnosticos, sincronizarPaciente, guardarSeccion, leerSeccion } from '../../utils/atencionBorrador';

DataTable.use(DataTablesCore);
export default {
    name: "Recetas",
    components: {
        VueFinalModal,
        DataTable,
        Pacientes,
        Inventario
    },
    mixins: [toastMixin],
    props: {
        consultaLista: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tokenAuth: localStorage.getItem("tokenAuth"),
            showModal: false,
            loadModalCie10: false,
            showModalInventario: false,
            showModalFirma: false,
            quiereFirmar: false,
            archivoFirma: null,
            claveFirma: '',
            mostrarClaveFirma: false,
            firmando: false,
            codigoConsulta: '',
            noGenerar: false,
            resetarMedicamentos: false,
            recetaGenerada: false,
            guardarConsultaDespues: false,
            textareaActivo: null, // Para rastrear qué textarea abrió el modal
            number: {
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 3
            },
            transactions2: [],
            searchTerm: '',
            cie10: {
                searchTerm: ''
            },
            columns2: [
                { data: null, render: (data, type, row, meta) => meta.row + 1 },
                { data: 'Codigo' },
                { data: 'Descriptor' }
            ],
            options2: {
                info: false,
                searching: false,
                responsive: true,
                lengthChange: false,
                ordering: false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: -1 }
                ],
                pageLength: 8,
                language: {
                    search: "Buscar:",
                    zeroRecords: "Lo sentimos, no se encontraron resultados",
                    processing: "Buscando. Espere por favor..."
                }
            }
        };
    },
    computed: {
        ...mapState('receta', [
            'paciente',
            'cie10Seleccionado',
            'signosAlarma',
            'observaciones',
            'medicamentos'
        ]),
        ...mapGetters('receta', ['hasSavedData']),
        diagnosticosReceta() {
            const seleccion = this.cie10Seleccionado || {}
            if (Array.isArray(seleccion.diagnosticos) && seleccion.diagnosticos.length) {
                return seleccion.diagnosticos
            }
            if (seleccion.codigo) {
                return [{ codigo: seleccion.codigo, nombre: seleccion.nombre }]
            }
            return []
        },
        mostrarFormularioReceta() {
            if (!this.codigoConsulta) return true
            return this.resetarMedicamentos && !this.noGenerar
        },
        textoBotonGenerar() {
            if (this.codigoConsulta && this.consultaLista) return 'Generar receta y guardar consulta'
            return 'Generar receta'
        }
    },
    watch: {
        '$route.query': {
            immediate: true,
            handler(newQuery) {
                const codigo = (newQuery && newQuery.cod_consulta) || ''
                const codigoPaciente = (newQuery && newQuery.cod_paciente) || ''
                if (!codigo) {
                    this.codigoConsulta = ''
                    return
                }
                this.codigoConsulta = codigo
                const borrador = sincronizarPaciente(codigoPaciente, codigo)
                const estado = borrador.reiniciado ? {} : (leerSeccion(codigoPaciente, 'Recetas') || {})
                this.noGenerar = Boolean(estado.noGenerar)
                this.resetarMedicamentos = Boolean(estado.resetarMedicamentos)
                this.recetaGenerada = Boolean(estado.recetaGenerada)
                this.$nextTick(() => this.$emit('dando-receta', this.resetarMedicamentos))
                if (borrador.reiniciado) {
                    this.clearReceta()
                } else {
                    this.loadRecetaData()
                }
                this.cargarPacienteAtencion(codigoPaciente)
                this.aplicarDiagnosticos(borrador.diagnosticos)
            }
        },
        'cie10.searchTerm': {
            handler() {
                this.cie10.searchTerm = this.cie10.searchTerm.toUpperCase();
                this.debouncedGetLista();
            },
            immediate: false
        }
    },

    methods: {
        ...mapActions('receta', [
            'setPaciente',
            'setFecha',
            'setCie10',
            'setSignosAlarma',
            'setObservaciones',
            'setMedicamentos',
            'addMedicamento',
            'removeMedicamento',
            'updateMedicamento',
            'clearReceta',
            'loadRecetaData'
        ]),

        loadModal() {
            this.showModal = true
        },

        aplicarDiagnosticoAtencion() {
            if (!this.codigoConsulta) return
            const lista = leerDiagnosticos(this.$route.query.cod_paciente)
            this.aplicarDiagnosticos(lista)
        },

        aplicarDiagnosticos(lista) {
            const diagnosticos = (lista || []).map((item) => ({
                codigo: item.Codigo || item.codigo || '',
                nombre: item.Descriptor || item.nombre || ''
            })).filter((item) => item.codigo)

            if (!diagnosticos.length) {
                this.setCie10({ codigo: '', nombre: '', diagnosticos: [] })
                return
            }

            this.setCie10({
                codigo: diagnosticos[0].codigo,
                nombre: diagnosticos[0].nombre,
                diagnosticos
            })
        },

        async cargarPacienteAtencion(codigoPaciente) {
            if (!codigoPaciente) return
            try {
                const response = await this.$https.post('/consulta/getLoadPacienteId', { codigoId: codigoPaciente }, {
                    headers: { Authorization: this.tokenAuth }
                })
                if (response.data.code !== 200 || !response.data.datos || !response.data.datos.length) return
                const paciente = response.data.datos[0]
                this.setPaciente({
                    cedula: paciente.cedula || '',
                    nombres: `${paciente.nombres || ''} ${paciente.apellidos || ''}`.trim(),
                    edad: this.calcularEdad(paciente.nacimiento),
                    fecha: this.paciente.fecha
                })
            } catch (error) {
                this.$toast.error("No se pudo cargar el paciente de la atención", { position: "top-right" })
            }
        },

        loadModal2() {
            this.loadModalCie10 = true
        },

        filaCompleta(medicamento) {
            if (!medicamento) return false;
            const cantidad = String(medicamento.cantidad ?? "").trim();
            const nombre = String(medicamento.nombre || "").trim();
            const indicaciones = String(medicamento.indicaciones || "").trim();
            return cantidad !== "" && nombre !== "" && indicaciones !== "";
        },

        estaLlena() {
            if (this.codigoConsulta) return this.noGenerar || this.recetaGenerada
            return (this.medicamentos || []).some((medicamento) => this.filaCompleta(medicamento));
        },

        guardarEnBorrador(codPaciente, codConsulta) {
            const codigo = codConsulta || this.codigoConsulta
            if (!codigo) return
            guardarSeccion(codPaciente || this.$route.query.cod_paciente, codigo, 'Recetas', {
                noGenerar: this.noGenerar,
                resetarMedicamentos: this.resetarMedicamentos,
                recetaGenerada: this.recetaGenerada
            })
        },

        getData() {
            return {
                noGenerar: this.noGenerar,
                recetaGenerada: this.recetaGenerada,
                resetarMedicamentos: this.resetarMedicamentos
            }
        },

        darReceta() {
            this.resetarMedicamentos = true
            this.noGenerar = false
            this.recetaGenerada = false
            this.setMedicamentos([{ cantidad: '', nombre: '', indicaciones: '' }])
            this.$emit('dando-receta', true)
            this.$emit('contenido')
            this.guardarEnBorrador()
        },

        quitarReceta() {
            this.resetarMedicamentos = false
            this.noGenerar = true
            this.recetaGenerada = false
            this.$emit('dando-receta', false)
            this.$emit('contenido')
            this.guardarEnBorrador()
        },

        alternarReceta() {
            if (this.resetarMedicamentos) this.quitarReceta()
            else this.darReceta()
        },

        continuarConsulta() {
            if (!this.guardarConsultaDespues) return
            this.guardarConsultaDespues = false
            this.$emit('guardar-consulta')
        },

        marcarRecetaGenerada() {
            if (!this.codigoConsulta) return
            this.recetaGenerada = true
            this.$emit('contenido')
            this.guardarEnBorrador()
        },

        invalidarRecetaGenerada() {
            if (!this.codigoConsulta || !this.recetaGenerada) return
            this.recetaGenerada = false
            this.$emit('contenido')
            this.guardarEnBorrador()
        },

        agregarFila() {
            if (!this.filaCompleta(this.medicamentos[0])) {
                this.$swal.fire({
                    title: "Fila incompleta",
                    text: "Completa el medicamento antes de añadir otro.",
                    icon: "warning",
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                });
                return;
            }
            this.addMedicamento();
            this.invalidarRecetaGenerada();
        },

        eliminarFila(index) {
            this.removeMedicamento(index);
            this.invalidarRecetaGenerada();
        },

        actualizarFecha(fecha) {
            this.setFecha(fecha);
        },

        fechaISO(fecha) {
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const dia = String(fecha.getDate()).padStart(2, '0');
            return `${fecha.getFullYear()}-${mes}-${dia}`;
        },

        handleDatosSeleccionados(resp) {
            if (resp && resp.cedula !== undefined && resp.cedula !== '') {
                const pacienteData = {
                    cedula: resp.cedula,
                    nombres: resp.nombres_pacientes,
                    edad: this.calcularEdad(resp.nacimiento),
                    fecha: this.paciente.fecha || this.fechaISO(new Date())
                };

                this.setPaciente(pacienteData);
                this.showModal = false;
            }
        },

        confirmarBorrarDatos() {
            this.$swal.fire({
                title: "¿Está seguro?",
                text: "¿Desea borrar todos los datos de la receta? Esta acción no se puede deshacer.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, borrar",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-outline-secondary ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.clearReceta();
                    this.$swal.fire({
                        title: "Datos borrados",
                        text: "Todos los datos han sido eliminados correctamente.",
                        icon: "success",
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                        buttonsStyling: false,
                    });
                }
            });
        },

        async generarReceta() {
            // Verificar si algún campo de los medicamentos está vacío
            const camposIncompletos = this.medicamentos.some(med =>
                !med.cantidad || !med.nombre.trim() || !med.indicaciones.trim()
            );

            if (camposIncompletos) {
                this.$swal.fire({
                    title: "Campos incompletos",
                    text: "Por favor, complete todos los campos antes de generar la receta.",
                    icon: "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                });
                return;
            }

            this.aplicarDiagnosticoAtencion()

            if (!this.diagnosticosReceta.length) {
                this.$swal.fire({
                    title: "Campos incompletos",
                    text: this.codigoConsulta
                        ? "Agrega el diagnóstico CIE-10 en la pestaña Diagnóstico."
                        : "Por favor, complete los campos del CIE-10.",
                    icon: "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                });
                return;
            }

            if (this.paciente.cedula === '') {
                this.$swal.fire({
                    title: "Campos incompletos",
                    text: "Por favor, escoge un paciente.",
                    icon: "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                });
                this.showModal = true
                return;
            }

            this.quiereFirmar = false
            this.archivoFirma = null
            this.claveFirma = ''
            this.mostrarClaveFirma = false
            this.guardarConsultaDespues = Boolean(this.codigoConsulta && this.consultaLista)
            this.showModalFirma = true
        },

        aceptarFirma() {
            this.quiereFirmar = true
        },

        volverPreguntaFirma() {
            this.quiereFirmar = false
            this.archivoFirma = null
            this.claveFirma = ''
            this.mostrarClaveFirma = false
            if (this.$refs.inputFirma) {
                this.$refs.inputFirma.value = ''
            }
        },

        cerrarModalFirma() {
            this.showModalFirma = false
            this.volverPreguntaFirma()
        },

        seleccionarArchivoFirma(event) {
            const archivo = event.target.files && event.target.files[0]
            if (!archivo) {
                this.archivoFirma = null
                return
            }

            if (!archivo.name.toLowerCase().endsWith('.p12')) {
                this.archivoFirma = null
                event.target.value = ''
                this.$swal.fire({
                    title: "Archivo no válido",
                    text: "Selecciona un certificado con extensión .p12.",
                    icon: "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                })
                return
            }

            this.archivoFirma = archivo
        },

        archivoABase64(archivo) {
            return new Promise((resolve, reject) => {
                const lector = new FileReader()
                lector.onload = () => {
                    const resultado = String(lector.result || '')
                    const coma = resultado.indexOf(',')
                    resolve(coma >= 0 ? resultado.slice(coma + 1) : resultado)
                }
                lector.onerror = () => reject(lector.error)
                lector.readAsDataURL(archivo)
            })
        },

        abrirPdfBase64(base64) {
            const limpio = String(base64 || '').replace(/^data:application\/pdf;base64,/, '').trim()
            const binario = atob(limpio)
            const bytes = new Uint8Array(binario.length)
            for (let i = 0; i < binario.length; i++) {
                bytes[i] = binario.charCodeAt(i)
            }
            const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
            return window.open(url, '_blank')
        },

        async confirmarFirma() {
            if (!this.archivoFirma || !this.claveFirma.trim()) {
                this.$swal.fire({
                    title: "Campos incompletos",
                    text: "Carga el certificado .p12 e ingresa la contraseña.",
                    icon: "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                })
                return
            }

            if (this.firmando) return
            this.firmando = true

            try {
                const datos = JSON.parse(localStorage.getItem("userData") || "{}")
                const receta = await crearPdfRecetaFirmable(
                    this.paciente,
                    this.medicamentos,
                    this.paciente.edad,
                    datos.especialidad,
                    this.cie10Seleccionado,
                    this.signosAlarma,
                    this.observaciones
                )
                const certificado = await this.archivoABase64(this.archivoFirma)
                const response = await this.$https.post('/especialidades/firmaSaveReceta', {
                    pdf: receta.pdf,
                    certificado,
                    clave: this.claveFirma,
                    pagina: receta.pagina,
                    posicionX: receta.posicionX,
                    posicionY: receta.posicionY,
                    cedulaPaciente: this.paciente.cedula,
                    nombresPaciente: this.paciente.nombres,
                    cedulaDoctor: datos.cedula || '',
                    especialidad: datos.especialidad || '',
                    cie10: this.cie10Seleccionado.codigo || '',
                    codigoConsulta: this.codigoConsulta
                }, {
                    headers: {
                        Authorization: this.tokenAuth
                    }
                })

                const pdfFirmado = response.data.pdf
                this.claveFirma = ''
                this.archivoFirma = null
                this.showModalFirma = false
                const ventanaPdf = this.abrirPdfBase64(pdfFirmado)
                this.marcarRecetaGenerada()
                if (this.guardarConsultaDespues) {
                    this.$nextTick(() => this.continuarConsulta())
                    return
                }
                const fueraDeAtencion = !this.codigoConsulta
                this.$swal.fire({
                    title: "Receta firmada",
                    text: fueraDeAtencion
                        ? "La receta se firmó. No se guardó porque está fuera de una atención."
                        : (response.data.guardado
                            ? "La receta firmada se generó correctamente."
                            : response.data.message),
                    icon: fueraDeAtencion || response.data.guardado ? "success" : "warning",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                }).then(() => {
                    if (!ventanaPdf) this.abrirPdfBase64(pdfFirmado)
                })
            } catch (error) {
                const message = error?.response?.data?.message || "No se pudo firmar la receta."
                this.$swal.fire({
                    title: "No se pudo firmar",
                    text: message,
                    icon: "error",
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn btn-primary"
                    },
                    buttonsStyling: false,
                })
            } finally {
                this.firmando = false
            }
        },

        async rechazarFirma() {
            this.showModalFirma = false
            await this.mostrarPdfReceta()
        },

        async mostrarPdfReceta() {
            let datos = JSON.parse(localStorage.getItem("userData"));

            await generatePdfReceta(this.paciente, this.medicamentos, this.paciente.edad, datos.especialidad, this.cie10Seleccionado, this.signosAlarma, this.observaciones)
            this.marcarRecetaGenerada()
            if (this.guardarConsultaDespues) {
                this.continuarConsulta()
                return
            }

            this.$swal.fire({
                title: "Receta generada",
                text: "La receta ha sido generada con éxito.",
                icon: "success",
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn btn-primary"
                },
                buttonsStyling: false,
            });
        },

        loadCie10All() {
            this.$https.post('/codigos/getLoadCie10All', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                if (response.data.code === 200) {
                    this.transactions2 = response.data.data;
                } else {
                    this.transactions2 = [];
                }
            }).catch(() => {
                this.$toast.error("Ocurrió un error inesperado", { position: "top-right" });
            });
        },

        loadCie10() {
            this.$https.post('/codigos/getloadCie10Search', { busqueda: this.cie10.searchTerm }, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                if (response.data.code === 200) {
                    this.transactions2 = response.data.datos;
                } else {
                    this.transactions2 = [];
                }
            }).catch(error => {
                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }

                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert();
                }
                throw error;
            });
        },

        agregarCie10(event) {
            const rowElement = event.target.closest("tr");
            if (!rowElement) return;

            const dataIndex = rowElement.dataset.index;
            const rowIndex = dataIndex !== undefined ? parseInt(dataIndex) : this.getActualDataIndex(rowElement);

            if (rowIndex < 0 || !this.transactions2[rowIndex]) return;

            const item = this.transactions2[rowIndex];

            this.setCie10({
                codigo: item.Codigo,
                nombre: item.Descriptor
            });
        },

        getActualDataIndex(rowElement) {
            const codigo = rowElement.cells[1].textContent;
            return this.transactions2.findIndex(item => item.Codigo === codigo);
        },

        toUppercase() {
            this.cie10.searchTerm = this.cie10.searchTerm.toUpperCase();
        },

        debouncedGetLista: debounce(function () {
            if (this.cie10.searchTerm.length === 0) {
                this.loadCie10All();
            } else if (this.cie10.searchTerm.length >= 3) {
                this.loadCie10();
            }
        }, 1000),

        // Métodos para manejar actualizaciones de campos
        actualizarSignosAlarma(event) {
            this.setSignosAlarma(event.target.value);
            this.invalidarRecetaGenerada();
        },

        actualizarObservaciones(event) {
            this.setObservaciones(event.target.value);
            this.invalidarRecetaGenerada();
        },

        abrirInventario(index) {
            this.textareaActivo = { index, campo: 'nombre' };
            this.showModalInventario = true;
        },

        handleKeydown(event, index, campo) {
            // Si se presiona Enter
            if (event.key === 'Enter') {
                // Obtener el valor actual del campo
                const valorActual = event.target.value.trim();
                
                // Si el campo está vacío, abrir el modal
                if (valorActual === '') {
                    event.preventDefault(); // Prevenir el salto de línea
                    this.textareaActivo = { index, campo }; // Guardar qué textarea abrió el modal
                    this.showModalInventario = true;
                }
                // Si hay contenido, permitir el salto de línea normal (no hacer nada)
            }
        },

        actualizarMedicamento(index, campo, valor) {
            this.updateMedicamento({ index, field: campo, value: valor });
            this.invalidarRecetaGenerada();
        },

        // Método para manejar la selección de medicamento desde el modal
        onMedicamentoSeleccionado(nombreMedicamento) {
            if (this.textareaActivo) {
                // Actualizar el medicamento correspondiente
                this.updateMedicamento({ 
                    index: this.textareaActivo.index, 
                    field: this.textareaActivo.campo, 
                    value: nombreMedicamento 
                });
                this.invalidarRecetaGenerada();
                
                // Limpiar la referencia del textarea activo
                this.textareaActivo = null;
            }
        },

        // Método para cerrar el modal
        cerrarModalInventario() {
            this.showModalInventario = false;
            this.textareaActivo = null; // Limpiar la referencia
        },

        calcularEdad(fechaNacimiento) {
            let hoy = new Date();
            let fechaNace = new Date(fechaNacimiento);
            let edad = hoy.getFullYear() - fechaNace.getFullYear();
            if (hoy.getMonth() < fechaNace.getMonth() ||
                (hoy.getMonth() === fechaNace.getMonth() && hoy.getDate() < fechaNace.getDate())) {
                edad--;
            }
            return edad;
        },

    },

    mounted() {
        if (!this.$route.query.cod_consulta) {
            this.loadRecetaData();
        }
        this.loadCie10All();
    },
    activated() {
        this.aplicarDiagnosticoAtencion();
    }
};

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}
</script>

<style scoped>
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

.receta-container {
    --receta-azul: #0078be;
    --receta-azul-suave: #e8f4fc;
    --receta-texto: #1f2a37;
    --receta-muted: #6b7c8f;
    --receta-borde: #e6edf5;
    --receta-fondo: #f4f7fb;
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: var(--receta-texto);
    padding-bottom: 4px;
}

.receta-header,
.block-head {
    display: flex;
    align-items: center;
    gap: 8px;
}

.receta-header {
    padding: 0 0 6px;
    border-bottom: 1px solid var(--receta-borde);
}

.header-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    font-size: 0.75rem;
    display: grid;
    place-items: center;
    background: var(--receta-azul-suave);
    color: var(--receta-azul);
    flex-shrink: 0;
}

.header-text {
    min-width: 0;
}

.receta-opciones {
    margin-bottom: 12px;
}

.receta-opciones p {
    margin: 0 0 12px;
    color: var(--receta-texto);
    font-size: 14px;
}

.header-text h6,
.block-head h6 {
    margin: 0;
    color: var(--receta-texto);
    font-size: 0.82rem;
    font-weight: 700;
}

.fecha-field {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 2px 0 0;
    color: var(--receta-muted);
    font-size: 0.68rem;
}

.fecha-field input {
    height: 24px;
    padding: 0 6px;
    border: 1px solid #e3eaf2;
    border-radius: 6px;
    background: #fff;
    color: var(--receta-texto);
    font-size: 0.72rem;
}

.fecha-field input:focus {
    outline: none;
    border-color: var(--receta-azul);
}

.header-text p,
.block-hint {
    margin: 1px 0 0;
    color: var(--receta-muted);
    font-size: 0.68rem;
}

.header-text i {
    margin-right: 4px;
}

.btn-limpiar,
.btn-accion,
.btn-generar,
.btn-icono {
    border: 0;
    cursor: pointer;
}

.btn-limpiar {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border-radius: 8px;
    background: #fff;
    color: #eb1265;
    border: 1px solid #f3d2dc;
    font-size: 0.7rem;
    font-weight: 700;
}

.btn-limpiar:hover {
    background: #fff5f8;
}

.receta-block {
    padding: 8px 10px;
    border: 1px solid var(--receta-borde);
    border-radius: 10px;
    background: #fff;
}

.block-head {
    justify-content: space-between;
    margin-bottom: 6px;
}

.block-head h6 i {
    margin-right: 6px;
    color: var(--receta-azul);
}

.btn-accion {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    padding: 4px 8px;
    border-radius: 8px;
    background: var(--receta-azul-suave);
    color: var(--receta-azul);
    font-size: 0.7rem;
    font-weight: 700;
}

.btn-accion:hover {
    background: #d7edf9;
}

.btn-accion-solido {
    background: var(--receta-azul);
    color: #fff;
}

.btn-accion-solido:hover {
    background: #005f96;
}

.datos-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
}

.datos-grid-cie {
    grid-template-columns: 180px minmax(0, 1fr);
}

.dato {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 5px 8px;
    border-radius: 8px;
    background: var(--receta-fondo);
}

.dato span {
    color: var(--receta-muted);
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
}

.dato strong {
    color: var(--receta-texto);
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.35;
    word-break: break-word;
}

.dato strong.is-empty {
    color: #8b9aab;
    font-weight: 500;
}

.campo-texto {
    min-height: 46px;
    border-radius: 8px;
    border: 1px solid #e3eaf2;
    background: var(--receta-fondo);
    font-size: 0.75rem;
    padding: 6px 8px;
    line-height: 1.3;
    resize: vertical;
}

.campo-texto:focus {
    border-color: var(--receta-azul);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(0, 120, 190, 0.12);
}

.table-responsive {
    overflow-x: auto;
}

.medicamentos-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 0.75rem;
}

.medicamentos-table th {
    padding: 4px 6px 6px;
    color: var(--receta-muted);
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-align: left;
    text-transform: uppercase;
    border-bottom: 1px solid var(--receta-borde);
}

.medicamentos-table td {
    padding: 4px 6px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f4f8;
}

.col-cantidad {
    width: 88px;
}

.col-accion,
.celda-accion {
    width: 64px;
    text-align: center;
}

.campo-con-accion {
    display: flex;
    align-items: flex-start;
    gap: 6px;
}

.campo-con-accion textarea {
    flex: 1;
}

.medicamentos-table .form-control {
    border-radius: 8px;
    border: 1px solid #e3eaf2;
    background: var(--receta-fondo);
    font-size: 0.72rem;
    padding: 3px 6px;
    line-height: 1.3;
}

.medicamentos-table .form-control:focus {
    border-color: var(--receta-azul);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(0, 120, 190, 0.12);
}

.btn-icono {
    width: 26px;
    height: 26px;
    border-radius: 8px;
    font-size: 0.7rem;
    display: inline-grid;
    place-items: center;
    flex-shrink: 0;
    background: var(--receta-azul-suave);
    color: var(--receta-azul);
}

.btn-icono:hover {
    background: #d7edf9;
}

.btn-icono-peligro {
    background: #fff5f8;
    color: #eb1265;
}

.btn-icono-peligro:hover {
    background: #fde7ee;
}

.receta-footer {
    display: flex;
    justify-content: flex-end;
}

.btn-generar {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 8px;
    background: var(--receta-azul);
    color: #fff;
    font-size: 0.78rem;
    font-weight: 700;
}

.btn-generar:hover {
    background: #005f96;
}

.inventario-shell {
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: 82vh;
}

.inventario-head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: #0078be;
    color: #fff;
}

.inventario-head-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: grid;
    place-items: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.18);
    font-size: 0.75rem;
}

.inventario-head-text {
    min-width: 0;
}

.inventario-head h6 {
    margin: 0;
    color: #fff;
    font-size: 0.84rem;
    font-weight: 700;
}

.inventario-head p {
    margin: 1px 0 0;
    color: rgba(255, 255, 255, 0.86);
    font-size: 0.68rem;
}

.inventario-cerrar {
    margin-left: auto;
    width: 26px;
    height: 26px;
    border: 0;
    border-radius: 8px;
    display: grid;
    place-items: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
    cursor: pointer;
}

.inventario-cerrar:hover {
    background: rgba(255, 255, 255, 0.28);
}

.inventario-body {
    padding: 10px 12px 12px;
    overflow: auto;
}

.firma-shell {
    --receta-azul: #0078be;
    --receta-texto: #1f2a37;
    --receta-muted: #6b7c8f;
    --receta-fondo: #f4f7fb;
    display: flex;
    flex-direction: column;
}

.firma-head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: #0078be;
    color: #fff;
}

.firma-head-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: grid;
    place-items: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.18);
    font-size: 0.75rem;
}

.firma-head-text {
    min-width: 0;
}

.firma-head h6 {
    margin: 0;
    color: #fff;
    font-size: 0.84rem;
    font-weight: 700;
}

.firma-head p {
    margin: 1px 0 0;
    color: rgba(255, 255, 255, 0.86);
    font-size: 0.68rem;
}

.firma-cerrar {
    margin-left: auto;
    width: 26px;
    height: 26px;
    border: 0;
    border-radius: 8px;
    display: grid;
    place-items: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
    cursor: pointer;
}

.firma-cerrar:hover {
    background: rgba(255, 255, 255, 0.28);
}

.firma-cerrar:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.firma-body {
    padding: 14px 16px 16px;
}

.firma-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 140px;
}

.firma-spinner {
    width: 34px;
    height: 34px;
    border: 3px solid #d7e6f3;
    border-top-color: #0078be;
    border-radius: 50%;
    animation: firma-spin 0.8s linear infinite;
}

.firma-loading-text {
    margin: 0;
    color: var(--receta-texto);
    font-size: 0.86rem;
    font-weight: 600;
}

@keyframes firma-spin {
    to {
        transform: rotate(360deg);
    }
}

.firma-pregunta {
    margin: 0 0 14px;
    color: var(--receta-texto);
    font-size: 0.86rem;
    font-weight: 600;
    text-align: center;
}

.firma-campo {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
}

.firma-campo span {
    color: var(--receta-muted);
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
}

.firma-campo input {
    width: 100%;
    border: 1px solid #e3eaf2;
    border-radius: 8px;
    background: var(--receta-fondo);
    color: var(--receta-texto);
    font-size: 0.78rem;
    padding: 7px 8px;
}

.firma-clave {
    position: relative;
}

.firma-clave input {
    padding-right: 36px;
}

.btn-ver-clave {
    position: absolute;
    top: 50%;
    right: 6px;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--receta-muted);
    display: grid;
    place-items: center;
    cursor: pointer;
}

.btn-ver-clave:hover {
    color: var(--receta-azul);
    background: rgba(0, 120, 190, 0.08);
}

.firma-campo input:focus {
    outline: none;
    border-color: var(--receta-azul);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(0, 120, 190, 0.12);
}

.firma-archivo {
    margin: -4px 0 10px;
    color: var(--receta-azul);
    font-size: 0.72rem;
    font-weight: 600;
}

.firma-acciones {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 6px;
}

.btn-firma {
    border: 0;
    border-radius: 8px;
    padding: 6px 14px;
    background: var(--receta-azul);
    color: #fff;
    font-size: 0.78rem;
    font-weight: 700;
    cursor: pointer;
}

.btn-firma:hover {
    background: #005f96;
}

.btn-firma-secundario {
    background: #eef3f8;
    color: var(--receta-texto);
}

.btn-firma-secundario:hover {
    background: #e3eaf2;
}

.btn-firma:disabled {
    opacity: 0.7;
    cursor: default;
}

@media (max-width: 768px) {
    .datos-grid,
    .datos-grid-cie {
        grid-template-columns: 1fr;
    }

    .receta-header,
    .block-head {
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .btn-limpiar,
    .btn-accion {
        margin-left: 0;
    }

    .medicamentos-table thead {
        display: none;
    }

    .medicamento-row {
        display: block;
        margin-bottom: 10px;
        padding: 8px;
        border: 1px solid var(--receta-borde);
        border-radius: 12px;
        background: var(--receta-fondo);
    }

    .medicamentos-table td {
        display: block;
        width: 100%;
        padding: 6px 0;
        border: 0;
    }

    .medicamentos-table td::before {
        content: attr(data-label);
        display: block;
        margin-bottom: 4px;
        color: var(--receta-muted);
        font-size: 0.68rem;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
    }

    .celda-accion {
        text-align: left;
    }

    .btn-generar {
        width: 100%;
        justify-content: center;
    }
}

</style>

<style>
.modal-inventario-overlay {
    z-index: 20000 !important;
}

.modal-content4.modal-inventario {
    z-index: 20001 !important;
    max-width: 640px;
    width: min(640px, 94vw);
    max-height: 82vh;
    padding: 0;
    overflow: hidden;
    border-radius: 14px;
    box-shadow: 0 18px 50px rgba(15, 35, 55, 0.22);
}

.modal-firma-overlay {
    z-index: 20000 !important;
}

.modal-content4.modal-firma {
    z-index: 20001 !important;
    max-width: 420px;
    width: min(420px, 94vw);
    padding: 0;
    overflow: hidden;
    border-radius: 14px;
    box-shadow: 0 18px 50px rgba(15, 35, 55, 0.22);
}

/* SweetAlert por encima de los modales de firma/inventario */
.swal2-container {
    z-index: 30000 !important;
}
</style>